export default [
  { path: '/base/company', name: 'BaseCompany', component: () => import(/* webpackChunkName: "base-company" */ './index.vue') }
]